import { hourOf } from "./time";
import { mulberry32, hashSeed } from "./rng";
import { controlOf } from "./factions";
import { restless } from "./reactions";
import type { WeatherKind, WorldState } from "./types";

const CYCLE: WeatherKind[] = ["clear", "overcast", "rain", "fog", "storm", "clear", "overcast", "rain"];

/**
 * Weight the roll instead of picking flat.
 *
 * A county whose well has been stirred does not get the same weather as a quiet
 * one. Nothing here is magic — it is the same seeded stream, leaning. Ember will
 * tell you the well is breathing; the Deniers will tell you it is a wet season.
 * Both are looking at this function.
 */
function weigh(w: WorldState, k: WeatherKind): number {
  const r = restless(w);
  const ember = controlOf(w, "ember");
  if (k === "clear") return 1 - r * 0.7;
  if (k === "fog") return 1 + r * 1.1 + ember * 1.4;
  if (k === "storm") return 1 + r * 1.3 + ember * 0.6;
  if (k === "overcast") return 1 + r * 0.2;
  return 1;
}

export function tickWeather(w: WorldState, dt: number): void {
  w.weatherT -= dt;
  if (w.weatherT > 0) return;
  const day = Math.floor(w.timeSec / 86400);
  const rng = mulberry32(hashSeed(w.seed, "wx", day, Math.floor(w.timeSec)));

  let total = 0;
  for (const k of CYCLE) total += weigh(w, k);
  let roll = rng() * total;
  let chosen: WeatherKind = CYCLE[0]!;
  for (const k of CYCLE) {
    roll -= weigh(w, k);
    if (roll <= 0) {
      chosen = k;
      break;
    }
  }
  w.weather = chosen;
  // Foul weather that the Hollow is driving does not blow over on schedule.
  w.weatherT = (180 + rng() * 420) * (chosen === "clear" ? 1 - restless(w) * 0.4 : 1);
}

export function visMul(w: WorldState): number {
  const night = hourOf(w.timeSec) < 5.5 || hourOf(w.timeSec) > 20.5 ? 0.45 : 1;
  const wx =
    w.weather === "fog" ? 0.55 : w.weather === "storm" ? 0.62 : w.weather === "rain" ? 0.82 : 1;
  return night * wx;
}

export function moveMul(w: WorldState): number {
  if (w.weather === "storm") return 0.86;
  if (w.weather === "rain") return 0.93;
  return 1;
}

export function rains(kind: WeatherKind): boolean {
  return kind === "rain" || kind === "storm";
}
